import { render, staticRenderFns } from "./typeActions.vue?vue&type=template&id=e3064fc4"
import script from "./typeActions.vue?vue&type=script&lang=js"
export * from "./typeActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports